import React, { useState } from 'react';
import Collapsible from 'react-collapsible';
import './Article.css';

const baseURL = "https://warehouse-picker-proxy.qustom.workers.dev/proxy";

const Article = ({ article, pickedArticles, setPickedArticles ,conneoId, batchId }) => {
  const [locationQuantities, setLocationQuantities] = useState({});
  const [error, setError] = useState('');
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isandersLocationCollapsed, setIsandersLocationCollapsed] = useState(false);

  const [isEditCollapsed, setIsEditCollapsed] = useState(false);
  const [totalPickedQuantity, setTotalPickedQuantity] = useState(
    pickedArticles[article.id]?.mainQuantity || 0
  );
  const [andersQuantity, setAndersQuantity] = useState('');
  const [editQuantity, setEditQuantity] = useState('');
  const [editAltQuantity, setEditAltQuantity] = useState('');
  const [loading, setLoading] = useState(false);
  //const [andersSelected , setAndersSelected] = useState(false)
  const [mainSelected , setMainSelected] = useState(false)
  const [collapsedLocation, setCollapsedLocation] = useState({});
  const [collapsedLocationEdit, setCollapsedLocationEdit] = useState({});
  const [disabledButtons, setDisabledButtons] = useState({}); // Track disabled state of buttons
  const [displayQuantities, setDisplayQuantities] = useState({});
  const [availableLocations, setAvailableLocations] = useState(
    article.locations.reduce((acc, location) => {
      acc[location.locationId] = location.available;
      return acc;
    }, {})

  ); // Track available stock per location
  const [buttonCaption, setButtonCaption] = useState(
    article.available < article.qty ? article.available : article.qty
  );
 // const [andersUsed, setAndersUsed] = useState({}); // Track whether Anders has been used for a location

  // Function to calculate the remaining quantity to be picked
  const calculateRemainingQuantity = () => {
    return Math.max(0, article.qty - totalPickedQuantity);
  };

  const handlePickDefaultQuantity = () => {
    if (article.available === 0) {
      setError('There is not enough stock available.');
      return;
    }
    if(Number(buttonCaption) > Number(article.available))
    {
      setError('Te weinig voorraad!');
      return;
    }
    const remainingQuantity = calculateRemainingQuantity();

    const mainQuantity = Math.min(remainingQuantity , buttonCaption);
    const totalAlternativeQuantity = Object.values(locationQuantities).reduce(
      (acc, qty) => acc + qty,
      0
    );
    const currentPickedQuantity = pickedArticles[article.id]?.mainQuantity || 0;
    const totalQuantity = mainQuantity + totalAlternativeQuantity + currentPickedQuantity;
    // console.log("total alternative quantity: " , remainingQuantity);
    console.log("main quantity: " , mainQuantity , currentPickedQuantity , totalQuantity);

    // console.log("from the main one: " , totalAlternativeQuantity)
    // if (totalQuantity > article.qty) {
    //   setError(`The total picked quantity (${totalQuantity}) exceeds the ordered quantity (${article.qty}).`);
    //   return;
    // }

    setButtonCaption(0);

    const updatedPickedArticles = {
      ...pickedArticles,
      [article.id]: {
        mainQuantity: mainQuantity + currentPickedQuantity,
        locations: locationQuantities,
      },
    };

    setPickedArticles(updatedPickedArticles);
    //console.log("PP default: " , JSON.stringify(pickedArticles))
    setTotalPickedQuantity(totalPickedQuantity + mainQuantity);
    setError('');
    setMainSelected(true);
    // Disable the green button if "Anders" was used
    setDisabledButtons((prev) => ({
      ...prev,
      [article.locationId]: true, // Disable the green button
    }));

  };

  const handleAddAndersQuantity = () => {
    if (article.available === 0) {
      setError('There is not enough stock available.');
      return;
    }

    const mainQuantity = Number(andersQuantity);
    const totalAlternativeQuantity = Object.values(locationQuantities).reduce((acc, qty) => acc + qty, 0);
    const currentPickedQuantity = pickedArticles[article.id]?.mainQuantity || 0;
    const totalQuantity = mainQuantity + totalAlternativeQuantity + currentPickedQuantity;

    const maxExpectedQty = article.available > article.qty ? article.qty : article.available;
    
    if (totalAlternativeQuantity > totalQuantity || article.available < totalQuantity) {
      setError('Exceeded the maximum available quantity!');
      return;
    }
    if (isNaN(mainQuantity) || mainQuantity <= 0 || totalQuantity > article.qty || mainQuantity > maxExpectedQty) {
      setError(`Please enter a valid quantity greater than 0 and ensure the total does not exceed the ordered quantity (${article.qty}).`);
      return;
    }
    
    //console.log("From main article:" , totalAlternativeQuantity , buttonCaption , mainQuantity ,  totalPickedQuantity + mainQuantity);
    const updatedButtonCaption = Math.max(0, buttonCaption - mainQuantity); // Ensure it doesn't go negative

    if (updatedButtonCaption < 0) {
      setError('The quantity entered exceeds the available stock.');
      return;
    }

    setButtonCaption(updatedButtonCaption);
    const updatedTotalPickedQuantity = totalPickedQuantity + mainQuantity;

    const updatedPickedArticles = {
      ...pickedArticles,
      [article.id]: {
        mainQuantity: currentPickedQuantity + mainQuantity,
        locations: locationQuantities,
      },
    };

    setPickedArticles(updatedPickedArticles);
    // console.log("PP andres: " , JSON.stringify(pickedArticles))
    setTotalPickedQuantity(updatedTotalPickedQuantity);
    setAndersQuantity('');
    setError('');
    //setAndersSelected(true);
  };

  const handleLocationQuantityChange = (locationId, value, availableForLocation) => {
    const inputQuantity = Math.max(0, Number(value)); // Ensure no negative values
    // Check if the input quantity exceeds the available quantity
    if (inputQuantity > availableForLocation) {
      setError(`You cannot pick more than the available quantity for this location.`);
      return;
    }

    setLocationQuantities({
      ...locationQuantities,
      [locationId]: inputQuantity,
    });

    // Mark "Anders" as used if the user enters a value
    // setAndersUsed((prev) => ({
    //   ...prev,
    //   [locationId]: true,
    // }));
  };

  const handleMainQuantityChange = (value) => {
    const inputQuantity = Math.max(0, Number(value)); // Ensure no negative values
    // Check if the input quantity exceeds the available quantity
    if (inputQuantity > article.available) {
      setError(`You cannot pick more than the available quantity for this location.`);
      return;
    }
    setAndersQuantity(value);
  };

  const handlePickDefaultQuantityLocation = (location) => {
    if (availableLocations[location.locationId] === 0) {
      setError('There is not enough stock available.');
      return;
    }
    if(Number(availableLocations[location.locationId]) > Number(location.available))
    {
      setError('Te weinig voorraad!');
      return;
    }
  
    const remainingQuantity = calculateRemainingQuantity();
    const currentPickedQuantity = pickedArticles[location.locationId]?.mainQuantity || 0;

    let pickedQuantity = Math.min(availableLocations[location.locationId], remainingQuantity);
    // console.log("from sub : ", pickedQuantity , currentPickedQuantity)
    pickedQuantity += currentPickedQuantity;
    
    const totalAlternativeQuantity = pickedQuantity + currentPickedQuantity + Object.values(locationQuantities).reduce((acc, qty) => acc + qty, 0);
  
    if (totalAlternativeQuantity > article.qty) {
      setError(`The total picked quantity exceeds the ordered quantity (${article.qty}).`);
      return;
    }
  
    // console.log("from sub default" , totalPickedQuantity ,pickedQuantity)
    setTotalPickedQuantity(Math.min(totalPickedQuantity + pickedQuantity , article.qty));
      // Update picked quantities for the location
    setLocationQuantities((prev) => ({
      ...prev,
      [location.locationId]: pickedQuantity,
    }));
    
    setPickedArticles((prevPickedArticles) => ({
      ...prevPickedArticles,
      [article.id]: {
        ...prevPickedArticles[article.id],
        locations: {
          ...prevPickedArticles[article.id]?.locations,
          [location.locationId]: (prevPickedArticles[article.id]?.locations[location.locationId] || 0) + Number(pickedQuantity)
        },
        },
    }));
  
    //console.log("from sub set picked quantity: " , location.locationId , JSON.stringify(pickedArticles));
    // Update available stock for the location
    setAvailableLocations((prev) => ({
      ...prev,
      [location.locationId]: prev[location.locationId] - pickedQuantity,
    }));
  
    // Disable the green button after clicking
    setDisabledButtons((prev) => ({
      ...prev,
      [location.locationId]: true, // Mark this location button as disabled
    }));
  
    // **Update the buttonCaption based on the remaining quantity to pick**
    //.log(currentPickedQuantity , article.qty ,totalAlternativeQuantity, pickedQuantity , totalPickedQuantity, remainingQuantity);
    const updatedButtonCaption = Math.max(0 , article.qty-(totalPickedQuantity + pickedQuantity));
    setButtonCaption(Math.min(updatedButtonCaption, article.available)); // Ensure it reflects the correct remaining quantity
   // console.log("updated button caption" , updatedButtonCaption);
    setError('');
  };
  
  const handleAddAndersQuantityLocation = (location) => {
    if (availableLocations[location.locationId] === 0) {
      setError('There is not enough stock available.');
      return;
    }
  
    const pickedQuantity = Math.min(Number(locationQuantities[location.locationId]), availableLocations[location.locationId]);
    const remainingQuantity = calculateRemainingQuantity();
  
    if (pickedQuantity > Math.min(remainingQuantity, availableLocations[location.locationId]))
    {
      setError(`you cannot pick more than the available quantity`);
      return;
    }
    // Validate the picked quantity against the available stock and remaining quantity
    if (isNaN(pickedQuantity) || pickedQuantity <= 0) {
      setError(`Please enter a valid quantity and ensure it does not exceed the available quantity for this location.`);
      return;
    }
  
    setLocationQuantities((prev) => ({
      ...prev,
      [location.locationId]: pickedQuantity,
    }));
  
    const updatedTotalPickedQuantity = totalPickedQuantity + pickedQuantity;
   // console.log("NEHAL Before: " , JSON.stringify(pickedArticles));

    setPickedArticles((prevPickedArticles) => ({
      ...prevPickedArticles,
      [article.id]: {
        ...prevPickedArticles[article.id],
        locations: {
          ...prevPickedArticles[article.id]?.locations,
          [location.locationId]: ((prevPickedArticles[article.id]?.locations[location.locationId] || 0) + Number(pickedQuantity)),
        },
      },
    }));
    
    //console.log("NEHAL: " , location.locationId , pickedQuantity,  JSON.stringify(pickedArticles));

    // Update available stock for the location
    setAvailableLocations((prev) => ({
      ...prev,
      [location.locationId]: prev[location.locationId] - pickedQuantity,
    }));
  
    // Disable the green button if "Anders" was used
    // setDisabledButtons((prev) => ({
    //   ...prev,
    //   [location.locationId]: true, // Disable the green button
    // }));
  
    // Mark "Anders" as used
    // setAndersUsed((prev) => ({
    //   ...prev,
    //   [location.locationId]: true,
    // }));
  
    setTotalPickedQuantity(updatedTotalPickedQuantity);
  
    // **Update the buttonCaption based on the remaining quantity to pick**
    const updatedButtonCaption = Math.max(0 , article.qty-updatedTotalPickedQuantity);
   // console.log(updatedButtonCaption);
    setButtonCaption(Math.min(updatedButtonCaption, article.available));
    //setButtonCaption(updatedButtonCaption);
    // setLocationQuantities({
    //   ...locationQuantities,
    //   [location.locationId]: 0,
    // });
    // After all your calculations, clear the display value
    setDisplayQuantities(prev => ({...prev, [location.locationId]: ''}));
    setError('');
  };
  
  const handleCollapsibleClick = () => {
    if(isEditCollapsed) setIsEditCollapsed(false);
    setIsCollapsed(!isCollapsed);
  };

  const handleEditCollapsibleClick = () => {
    setIsEditCollapsed(!isEditCollapsed);
    if(isCollapsed) setIsCollapsed(false);
    setCollapsedLocationEdit((prev) => {
      const updatedCollapsedState = {};
      Object.keys(prev).forEach((key) => {
        updatedCollapsedState[key] = false;
      });
        return updatedCollapsedState;
    });
  };

  const handleEditCollapsibleAltClick = (locationId) => {
    collapsedLocation[locationId] = false;
    setIsEditCollapsed(false);
    // setCollapsedLocationEdit((prev) => ({
    //   ...prev,
    //   [locationId]: !prev[locationId],
    // }));
    setCollapsedLocationEdit((prev) => {
      const updatedCollapsedState = {};
        // Loop through existing state and set all to false except the clicked location
      Object.keys(prev).forEach((key) => {
        updatedCollapsedState[key] = key === locationId ? !prev[key] : false;
      });

      // Ensure that the clicked location always exists in the updated state
      updatedCollapsedState[locationId] = !prev[locationId];
        return updatedCollapsedState;
    });
  };

  const handleEditMainQuantity = async () => {
      setLoading(true); // Start loader
      try {
        const payload = {
          articleId: article.paperid,
          code: '',
          articleType: 100,
          quantity: editQuantity,
          locationId: article.locationId,
        };
        const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);
        else  
        { 
          article.available = data.data.stock;
          setButtonCaption(Math.min(data.data.stock,(article.qty - totalPickedQuantity)))
        }

      } catch (error) {
        alert(error.message);
        console.error(error.message);
      } finally {
        setLoading(false); // Stop loader
      }

    setEditQuantity('');
    setIsEditCollapsed(false)
  };

  const handleEditAltQuantity = async (location) => {
      setLoading(true); // Start loader
      try {
        const payload = {
          articleId: article.paperid,
          code: '',
          articleType: 100,
          quantity: editAltQuantity ,
          locationId: location.locationId,
        };

        
        const response = await fetch(`${baseURL}/${conneoId}/${batchId}/correctstock`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        if (!response.ok || data.meta.status !== 'success') throw new Error(data.meta.error);
        else 
        { 
          location.available = data.data.stock;
          availableLocations[location.locationId] = Math.min(data.data.stock ,(article.qty - totalPickedQuantity));
        }

      } catch (error) {
        alert(error.message);
        console.error(error.message);
      } finally {
        setLoading(false); // Stop loader
      }
    setEditAltQuantity(null);
    handleEditCollapsibleAltClick(location.locationId);
  };

  const toggleLocationCollapsible = (locationId) => {
    setCollapsedLocation((prev) => ({
      ...prev,
      [locationId]: !prev[locationId],
    }));
    collapsedLocationEdit[locationId] = false;
  };

  const displayDescription = (article) => {
    const normalizedArticleCode = article.articleCode.replace(/[-_]/g, '');
    const normalizedDescription = article.description.replace(/[-_]/g, '');

    if (article.articleCode.includes(article.description))
      return `${article.orderNumber} - ${article.articleCode}`;

    const baseArticleCode = normalizedArticleCode.replace(/\d*$/, ''); // Remove any trailing digits
    return normalizedDescription.startsWith(baseArticleCode)
      ? article.orderNumber + ' - ' + article.description
      : `${article.orderNumber} - ${article.articleCode} - ${article.description}`;
  };

  return (
    <div className="article-card" style={{
      backgroundColor: totalPickedQuantity === 0 
        ? 'white' 
        : totalPickedQuantity === article.qty 
          ? '#95C3A7' 
          : '#FEF5B5'
    }}>
        {loading && (
        <div className="fullscreen-loader">
          <div className="spinner"></div>
        </div>
      )}
      <h3>{displayDescription(article)}</h3>
      <div className="article-details">
        <p>
          <strong>{article.location}</strong> ({article.warehouse}) [{article.available}]
        </p>
        <p><strong>Besteld: </strong> {article.qty}</p>
        <p><strong>Gepakt:  {totalPickedQuantity} </strong> </p>
        <div className="button-group">
          <button onClick={handlePickDefaultQuantity} className="btn-default" 
           disabled={buttonCaption === 0  || disabledButtons[article.locationId]}>
            {(mainSelected)? 0 : buttonCaption}
          </button>
          <button
            onClick={handleCollapsibleClick}
            className="btn-anders"
            disabled={buttonCaption === 0 || disabledButtons[article.locationId]} // Disable "Anders" when buttonCaption is 0
          >
            Anders
          </button>
          {/* New Edit Button */}
          <button
            onClick={handleEditCollapsibleClick}
            className="btn-edit"
          >
            <span className="edit-icon"> ✎</span>
          </button>
        </div>
        {isCollapsed && (
          <div className="anders-input-group">
            <input
              type="number"
              value={andersQuantity}
              onChange={(e) => handleMainQuantityChange(e.target.value)}
              placeholder="Aantal gepakt"
              className="input-quantity anders-input"
            />
            <button onClick={handleAddAndersQuantity} className="btn-check-mark">
              ✔
            </button>
          </div>
        )}

      {isEditCollapsed && (
          <div className="anders-input-group">
            <input
              type="number"
              value={editQuantity}
              onChange={(e) => setEditQuantity(e.target.value)}
              placeholder="Aantal wijzigen"
              className="input-quantity anders-input"
              disabled={loading} // Disable input while loading
            />
            <button onClick={handleEditMainQuantity} className="btn-check-mark-edit" disabled={loading}>
            {loading ? 'Processing...' : '✔'}
            </button>
          </div>
        )}
      </div>

      {article.locations && article.locations.length > 0 && (
        <Collapsible
          trigger={<div className={`collapsible-trigger ${isandersLocationCollapsed ? '' : 'active'}`}>Andere locaties</div>}
          open={isandersLocationCollapsed}
          className="collapsible"
          onClick={() => setIsandersLocationCollapsed(!isandersLocationCollapsed)}
        >
          {article.locations.map((location, index) => {
            const remainingQuantity = calculateRemainingQuantity();
            const availableForLocation = Math.max(0 , Math.min(remainingQuantity, availableLocations[location.locationId]));
            const pickedForLocation = locationQuantities[location.locationId] || 0;
            const isLocationFullyPicked = pickedForLocation >= availableForLocation;

            return (
              <div key={index} className="alternative-location">
                <p>
                  <strong>{location.location}</strong> ({location.warehouse}) [{location.available}]
                </p>
                <div className="button-group">
                  <button
                    onClick={() => handlePickDefaultQuantityLocation(location)}
                    className="btn-default" 
                    disabled={disabledButtons[location.locationId] || availableForLocation === 0} // Disable if green button clicked
                  >
                    {availableForLocation}
                  </button>
                  <button
                    onClick={() => toggleLocationCollapsible(location.locationId)}
                    className="btn-anders"
                    disabled={availableForLocation === 0 || isLocationFullyPicked || disabledButtons[location.locationId]} // Disable after default quantity is picked
                  >
                    Anders
                  </button>
                  <button
                  onClick={() => handleEditCollapsibleAltClick(location.locationId)}
                  className="btn-edit"
                 >
                  <span className="edit-icon"> ✎</span>
                </button>
                </div>
                {collapsedLocation[location.locationId] && (
                  <div className="anders-input-group">
                    <input
                      type="number"
                      value={displayQuantities[location.locationId] || ''}
                      placeholder="Aantal gepakt"
                      className="input-quantity anders-input"
                      onChange={(e) => {
                        // Update both display and actual quantities
                        setDisplayQuantities(prev => ({...prev, [location.locationId]: e.target.value}));
                        handleLocationQuantityChange(location.locationId, e.target.value, availableForLocation);
                      }}
                    />
                    <button
                      onClick={() => handleAddAndersQuantityLocation(location)}
                      className="btn-check-mark"
                      disabled={Number(locationQuantities[location.locationId]) > availableForLocation} // Disable if input exceeds available
                    >
                      ✔
                    </button>
                  </div>
                )}
              {collapsedLocationEdit[location.locationId] && (
                   <div className="anders-input-group">
                   <input
                     type="number"
                     value={editAltQuantity}
                     onChange={(e) => setEditAltQuantity(e.target.value)}
                     placeholder="Aantal wijzigen"
                     className="input-quantity anders-input"
                     disabled={loading}
                   />
                   <button onClick={() => handleEditAltQuantity(location)} className="btn-check-mark-edit" disabled={loading}>
                   {loading ? 'Processing...' : '✔'}
                   </button>
                 </div>
                )}
              </div>
            );
          })}
        </Collapsible>
      )}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default Article;